// extracted by mini-css-extract-plugin
module.exports = {"totContainer":"style_totContainer__2T04l"};